module.exports = __webpack_public_path__ + "img/avatar-86.13303cf2.png";